import React from "react";
import Icon from "@mdi/react";
import { mdiCheck } from "@mdi/js";

export default ({ count = 3, current, setCurrent }) => {
  const steps = Array.from({ length: count }).fill(0);

  return (
    <div className="stepper">
      {steps.map((val, index) => (
        <React.Fragment key={index}>
          <div
            className={`stepper_step ${index === current ? "-current" : ""} ${
              index < current ? "-before" : "-after"
            }`}
            onClick={() => {
              if (index < current) setCurrent(index);
            }}
          >
            {index < current ? (
              <Icon path={mdiCheck} color="#ff4d3b" size="16px" />
            ) : (
              `0${index + 1}`
            )}
          </div>
          {index < steps.length - 1 && (
            <div
              className={`stepper_separator ${
                index < current ? "-before" : "-after"
              }`}
            ></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
